import {
  ConversationTypeEnum,
  IInboxMessageHandler
} from "@coxauto-ui/cxm/communications/interfaces";

/**
 * Helper function to notify parent window about communication sent events.
 * Should only be called when isIframeMode is true and inboxMessageHandler exists.
 *
 * @param inboxMessageHandler - The message handler instance
 * @param communicationType - Type of communication: "EMAIL", "TEXT", or "CALL"
 * @param currentConversationType - The current conversation type (for conditional taskId logic)
 * @param success - Whether the communication was sent successfully
 * @param hasActiveTask - Whether there is still an active task (prevents duplicate taskId after completion)
 * @param subject - Optional email subject
 * @param attachmentCount - Optional number of attachments
 */
export function notifyCommunicationSent(
  inboxMessageHandler: IInboxMessageHandler,
  communicationType: "EMAIL" | "TEXT" | "CALL",
  currentConversationType: ConversationTypeEnum,
  success: boolean,
  hasActiveTask: boolean,
  subject?: string,
  attachmentCount?: number
): void {
  try {
    inboxMessageHandler.sendCommunicationSent(
      communicationType,
      currentConversationType,
      success,
      hasActiveTask,
      subject,
      attachmentCount
    );
  } catch (error) {
    console.error(
      "[notifyCommunicationSent] Failed to send communication notification:",
      error
    );
  }
}
